module.exports = __webpack_public_path__ + "static/media/ucd.c2bfe23a.png";